@for (message of messages; track message) {
    <app-chat-message [message]="message" />
}
